<template>
    <div class="container order-page">
        <ul class="body render-box" v-if="productInfo.list.length>0">

            <li 
                v-for="(item, index) in productInfo.list" :key="index"
                class="body-item f-s-b"
            >

                <div class="icon-box" v-touch:tap="tapItem(item)">
                    <i v-if="item.type" class="iconhebei icondui icon-size"></i>
                    <i v-else class="iconhebei iconweixuanzhong icon-size"></i>
                </div>

                <van-image 
                    v-touch:tap="goToDetail(item)"
                    class="body-item-image"
                    lazy-load
                    :src="item.image"
                />

                <ul class="product-info f-s-b">
                    <li v-touch:tap="goToDetail(item)" class="name ellipsis2">{{item.name}}</li>
                    <li v-touch:tap="goToDetail(item)" class="name sku ellipsis">规格:  {{item.sku}}</li>
                    <li class="price ellipsis2 f-s-b" >
                        <div class="left-price g-b-500" v-touch:tap="goToDetail(item)">
                            <span class="rmb">¥</span>
                            <span class="number">{{item.price}}</span>
                        </div>
                        <van-stepper
                            :value="item.number"
                            async-change
                            :min="item.min"
                            :max="item.max"
                            @plus="onChange(item,'plus')"
                            @minus="onChange(item,'minus')"
                        />
                    </li>
                </ul>

            </li>

        </ul>

        <div v-else class="f-c no-data">
            <div>(´･ω･)ﾉ(._.`)</div>
            <div>购物车里空空的</div>
        </div>

        <div class="foot f-s-b">
            <div class="all-box">
                <span class="all-btn" v-touch:tap="allChaneg">
                    <i v-if="all" class="iconhebei iconxuanzhong icon-size"></i>
                    <i v-else class="iconhebei iconweixuanzhong icon-size"></i>
                    <i class="txt">全选</i>
                </span>
                <span v-show="showDeleteBtn" class="delete-btn txt" v-touch:tap="deleteProduct">删除</span>
            </div>
            <div class="f-s-b">
                <div class="foot-left f-c ellipsis g-b-500">
                    <span class="f-c">合计:</span>
                    <span class="rmb">¥</span>
                    <span class="number ">{{productInfo.orderPrice}}</span>
                </div>
                <div class="foot-right f-s-b g-b-500">
                    <div class="f-c first-buy" v-touch:tap="routerPage">结算</div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { 
        Stepper,
        Field, 
    } from 'vant';

    import {
        // productDetailUrl,
        // productCommentListUrl,
        saveShoppingCartUrl,
        getShoppingCartUrl,
    } from '@js/shoppingUrl.js';
    import http from '@js/http-hbt.js';
    export default {
        data() {
            return {
                all: false,
                productInfo: {
                    list:[
                        {
                            image:require('@image/home/wanglili.png'),
                            name: '2020年 满汉全席日历 日历菜谱与传统文化相结合碗碟',
                            sku: '圆形5CM*5CM',
                            price: '45',
                            min: 1,
                            max: 3,
                            number: 1,
                            type: false,
                        },
                        {
                            image:require('@image/home/wanglili.png'),
                            name: '2020年 满汉全席日历 日历菜谱与传统文化相结合碗碟',
                            sku: '圆形5CM*5CM',
                            price: '45',
                            min: 3,
                            max: 3,
                            number: 1,
                            type: false,
                        },
                    ],
                    //  优惠
                    discount: 3,
                    remarks: '',
                    orderPrice: '0.00'
                },
                timer: 200,
            }
        },
        created() {
            this.productInfo.list = [];
            //  清空临时本地购物车
            this.$store.commit('setShopCar');
            this.getShoppingCart();
        },
        mounted() {
            this.prohibitInput();
        },
        methods: {
            prohibitInput(){
                var inputS = document.getElementsByTagName('input');
                for (let index = 0, len = inputS.length; index < len; index++) {
                    const element = inputS[index];
                    element.readOnly = true;
                }
            },
            fnThrottle(method, delay, duration) {
                var that = this;
                var timer = this.timer;
                var begin = new Date().getTime();
                return function() {
                    var current = new Date().getTime();
                    clearTimeout(timer);
                    if (current - begin >= duration) {
                        method();
                        begin = current;
                    } else {
                        that.timer = setTimeout(function() {
                        method();
                        }, delay);
                    }
                };
            },
            deleteProduct(){
                this.$dialog.confirm({
                    title: '提示',
                    message: '确认删除所选中的商品?'
                }).then(() => {
                    var tempArray = this.productInfo.list;
                    for (let index = tempArray.length -1 , len = 0; index >= len; index--) {
                        let element = tempArray[index];
                        if(element.type === true){
                            tempArray.splice(index,1);
                        }
                    }
                    this.changeShoppingCarData(true);
                }).catch(() => {
                });
            },
            goToDetail(item){
                return ()=>{
                    var {
                        rawData: {
                            productId = ''
                        }
                    } = item;
                    if(productId){
                        this.$router.push({ name: 'productDetail', query: { id: productId } })
                    }
                }
            },
            tapItem(item){
                return ()=>[
                    item.type = !item.type
                ]
            },
            getShoppingCart(){
                http.post(getShoppingCartUrl,{ userId: this.getUserId, searchWord: '' })
                    .then(res=>{
                        // console.log('购物车数据', res)
                        var{
                            data: array = []
                        } = res;
                        if(array.length>0){
                            array.map(item=>{
                                let commitData = {
                                    skuId: item.skuId,
                                    productId: item.productId,
                                    cartNum: item.cartNum,
                                }
                                this.productInfo.list.push({
                                    image: `${this.getImagePrefix+item.coverUrl}`,
                                    name: item.productName,
                                    sku: item.skuName,
                                    price: item.productPrice,
                                    min: 1,
                                    max: item.stockNum,
                                    number: item.cartNum,
                                    type: false,
                                    rawData: item,
                                    commitData,
                                })
                            })
                            this.prohibitInput();
                        }
                    })
            },
            allChaneg(){
                this.all = !this.all;
                var array = this.productInfo.list,
                    falg = false;
                if(this.all){
                    falg = true;
                }else{
                    falg = false;
                }
                array.map(item=>{
                    item.type = falg;
                })
            },
            routerPage(){
                var flag = false;
                this.productInfo.list.map(item=>{
                    if(item.type === true){
                        flag = true;
                        let data = {
                            productId: item.commitData.productId,
                            skuId: item.commitData.skuId,
                            number: item.commitData.cartNum,
                            rawData: item,
                        }
                        this.$store.commit('addToShopCar',data);
                    }
                })
                if(flag){
                    this.$router.push({ name: 'orderPage', query: { typeNumber: 2 } })
                }else{
                    this.$toast('未选中商品');
                }
            },
            onChange(item,type) {
                //  注释了假的异步交互添加数据 是为了给节流让路
                // this.$toast.loading({ forbidClick: true });
                // setTimeout(() => {
                    if(type === 'plus'){
                        item.number++
                    }else{
                        item.number--
                    }
                    item.commitData.cartNum = item.number;
                    // this.$toast.clear();
                    this.fnThrottle(this.changeShoppingCarData,500,1000)()
                // }, 500);
            },
            changeShoppingCarData(flag = false){
                let tempArray = [];
                this.productInfo.list.map(item=>{
                    tempArray.push(item.commitData)
                })
                var data = {
                    userId: this.getUserId,
                    content: JSON.stringify(tempArray),
                };
                this.saveShoppingCart(data, flag);
            },
            saveShoppingCart(data, flag = false){
                http.post(saveShoppingCartUrl, data).then(res=>{
                    if(flag){
                        this.$toast.success('删除商品成功');
                    }
                })
            },
        },
        computed: {
            showDeleteBtn(){
                this.productInfo.orderPrice = '0.00';
                let array = this.productInfo.list,
                    falg = false,
                    tempArray = [];
                    array.map(item=>{
                        if(item.type === true){
                            this.productInfo.orderPrice = Number(this.productInfo.orderPrice) + ( Number(item.price) * Number(item.number) )
                            falg = true;
                            tempArray.push(item.type)
                        }
                    })
                if(tempArray.length === this.productInfo.list.length){
                    this.all = true;
                }else{
                    this.all = false;
                }
                return falg;
            },
            getUserId(){
                return this.$store.state.userInfo.userId || '';
            },
            getImagePrefix(){
                return this.$store.state.shoppingBlock.bgImgPrefix || "";
            },
        },      
        components: {
            [Stepper.name]: Stepper,
            [Field.name]: Field,
        },
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        height: ~"calc(100% - 60px)" !important;
        position: relative;
        padding: 7px;
        .render-box{
            background:rgba(255,255,255,1);
            box-shadow:0px 1px 8px 0px rgba(212,206,218,0.5);
            border-radius:5px;
            margin-bottom: 12px;
            padding: 13px 14px;
        }
        .icon-image{
            width:33px;
            height:33px;
            // border-radius: 100%;
            // overflow: hidden;
        }
        .header{
            .user-info{
                box-sizing: border-box;
                padding-left: 10px;
                width: ~"calc(100% - 33px)";
                justify-content: flex-start;
                flex-direction: column;
                font-size: 13px;
                color: #A6A6A6;
                div{
                    width: 100%;
                }
                .info-top{
                    font-size: 14px;
                    .name{
                        color: #343434;
                    }
                    .phone{
                        font-size: 12px;
                        margin-left: 10px;
                    }
                    margin-bottom: 13px;
                }
                .info-below{
                    .address{

                    }
                }
            }
        }
        .body{
            font-size: 12px;
            .body-item{
                @imgeSize:86px;
                border-bottom: .5px solid #EAEAEA;
                padding-bottom: 18px;
                margin-bottom: 18px;
                box-sizing: border-box;
                .icon-box{
                    width: 20px;
                    .icon-size{
                        color: #ff3f36;
                        &::before{
                            font-size: 14px;
                        }
                    }
                }
                &:last-of-type{
                    margin-bottom: 0;
                    padding: 0;
                    border: 0;
                }
                // height: @imgeSize;
                .body-item-image{
                    width: @imgeSize;
                    height: @imgeSize;
                    border-radius:4px;
                    overflow: hidden;
                }
                .product-info{
                    color: #35373C;
                    flex-direction: column;
                    align-items: flex-start;
                    box-sizing: border-box;
                    height: auto;
                    // width: calc(~"100% - @{imgeSize}");
                    width: calc(~"100% - 106px");
                    padding-left: 15px;
                    .price{
                        width: 100%;
                        .left-price{
                            color: #FF7613;
                            .number{
                                font-size: 18px;
                            }
                        }
                    }
                    .sku{
                        margin: 8px 0;
                    }
                }
            }
            .product-info-row{
                font-size: 12px;
                color: #595959;
                .price{
                    color: #FF9142;
                }
                .left-font{
                    width: 90px;
                }
            }
            .you-hui{
                margin-bottom: 10px;
            }
            .total{
                justify-content: flex-end;
                .price{
                    font-size: 18px;
                }
                .total-number{
                    color: #B4B4B4;
                    font-weight: 400;
                }
                .txt{
                    margin: 0 10px;
                    color: #35373C;
                }
            }
        }
        .no-data{
            flex-direction: column;
            height: 100%;
        }
        .pay-box{
            font-size: 13px;
            color: #2B2B2B;
            .pay-image{
                width: 24px;
                height: 24px;
            }
            .wei-xin{
                height: auto;
            }
            .pay-right{
                color: #6C6C6C;
            }
            .txt{
                margin: 0 10px;
            }
        }
        .foot{
            height: 40px;
            overflow: hidden;
            position: fixed;
            left: 0;
            right: 0;
            bottom: 0;
            background:rgba(255,255,255,1);
            border-top-left-radius:5px;
            border-top-right-radius:5px;
            padding: 10px 12px;
            .foot-left{
                // width: ~'calc(100% - 100px)';
                margin-right: 10px;
                justify-content: flex-start;
                color: #686868;
                line-height: 18px;
                .icon-size{
                    color: #9C9C9C;
                }
                font-size: 12px;
                .rmb{
                    margin-left: 5px;
                    height: 100%;
                    color: #FF9142;
                    display: inline-block;
                    transform: translateY(1px);
                }
                .number{
                    color: #FF9142;
                    font-size: 18px;
                }
            }
            .foot-right{
                width:96px;
                background:linear-gradient(162deg,rgba(255,163,0,1) 0%,rgba(255,126,154,1) 100%);
                border-radius:1000px;
                font-size: 13px;
                height:40px;
                box-sizing: border-box;
                overflow: hidden;
                color: #ffffff;
                .add-shopping-car{
                    box-sizing: border-box;
                    width: 110px;
                    height:100%;
                    background:linear-gradient(146deg,rgba(255,200,2,1) 0%,rgba(254,151,1,1) 100%);
                }
                .first-buy{
                    box-sizing: border-box;
                    width: 110px;
                    height:100%;
                }
            }
            .all-box{
                font-size: 12px;
                color: #666666;
                .all-btn{
                    .icon-size{
                        color: #ff3f36;
                        &::before{
                            font-size: 14px;
                        }
                    }
                }
                .delete-btn{
                    margin-left: 5px;
                }
                .txt{
                    font-weight: 500;
                    margin-left: 5px;
                }
            }
        }
    }
</style>